import * as angular from "angular";
import {IController} from "angular";

export class SelectVerticalsCtrl implements IController {

  selectedVerticals: any;
  loading: boolean;

  onSelect: Function;

  private verticalTypes: any;
  private searchTerm: any;

  constructor(private businessCategories, private $element) {
  }

  $onInit() {
    this.verticalTypes = this.businessCategories;
    this.searchTerm = '';

    this.$element.find('input').on('keydown', (ev) => {
      ev.stopPropagation();
    });
  }

  submit() {
    this.searchTerm = '';
    this.onSelect({selected: this.selectedVerticals})
  }
}

angular
  .module('bringoz.admin.agents')
  .component('selectVerticals', {
    bindings: {
      selectedVerticals: '<',
      loading: '<?',
      onSelect: '&'
    },
    template: require('./select-verticals.html').default,
    controller: SelectVerticalsCtrl
  });
